import React from "react";
import { setCookie, getCookieValue } from "../Utiilities/Cookies";

class CookiePolicy extends React.Component {
  state = {
    classes: ""
  };

  hide = () => {
    this.setState({ classes: "" });
    let app = document.getElementById("app");

    if (app) {
      app.classList.remove("cookie-policy");
    }
    setCookie("allowsCookies", "true", 365);
  };

  componentDidMount() {
    let cookie = getCookieValue("allowsCookies");

    if (cookie !== "true") {
      this.setState({ classes: "show" });
      let app = document.getElementById("app");

      if (app) {
        app.classList.add("cookie-policy");
      }
    }
  }

  render() {
    return (
      <div id="CookiePolicy" className={this.state.classes}>
        <div className="main-container">
          <div className="cookie-content">
            <div>
              We’ve updated our <a href="/privacy-policy">Privacy Policy</a> to make it clearer how we use your personal
              data.
              <br />
              Please read our <a href="/cookie-policy">Cookie Policy</a> to learn how we use cookies to provide you with
              a better experience.
            </div>
            <button onClick={this.hide}>I UNDERSTAND</button>
          </div>
        </div>
      </div>
    );
  }
}

export default CookiePolicy;
